import React, { useEffect, useState } from "react"
import Page from "../../common/page/Page"
import axios from "axios"
import ButtonArea from "../../common/ButtonArea/ButtonArea"
import Form from "../../common/form/Form"
import ResponsiveTable from "../../common/ResponsiveTable/ResponsiveTable"
import EditIcon from "../../icons/EditIocn"
import DoubleArrowIcon from "../../icons/DoubleArrowIcon"
import Loader from "../../common/loader/Loader"
import ToggleOffIcon from "../../icons/ToggleOffIcon"
import ToggleOnIcon from "../../icons/ToggleOnIcon"
import DeleteIcon from "../../icons/DeleteIcon"
import { useAuth } from "../../data/useAuth"

const ChargePage = () => {
  const [charge, setCharge] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [formActive, setFormActive] = useState(false)
  const [isAdd, setIsAdd] = useState(true)
  const { signOut } = useAuth()
  const types = ["Payment Gateway"]
  const [formData, setFormData] = useState({
    type: "",
    amount: "",
    description: "",
  })

  useEffect(() => {
    fetchStates()
  }, [])

  const fetchStates = async () => {
    try {
      const response = await axios.get("/api/Charges")
      console.log(response.data)
      setCharge(response.data || [])
    } catch (err) {
      setError(err.response?.data?.message || err.message)
      signOut()
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (e) => {
    const { id, value } = e.target
    setFormData((prev) => ({ ...prev, [id]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!formData.type.trim()) {
      alert("Charge type is required.")
      return
    }
    // if (formData.delivery_rate === "" || isNaN(formData.delivery_rate)) {
    //   alert("Delivery rate is required and must be a number.")
    //   return
    // }

    try {
      setLoading(true)
      setFormActive(false)
      if (isAdd) {
        // console.log("formData", formData)
        const response = await axios.post("/api/charges", formData)
        setCharge((prev) => [...prev, response.data])
      } else {
        await axios.put(`/api/charges/${formData.id}`, formData)
        setCharge((prev) =>
          prev.map((state) =>
            state.id === formData.id ? { ...state, ...formData } : state
          )
        )
      }

      // setFormActive(false)
      resetForm()
      setLoading(false)
    } catch (err) {
      setFormActive(false)
      setLoading(false)
      setError(err.response?.data?.error || err.message)
    }
  }

  const resetForm = () => {
    setFormData({
      type: "",
      amount: "",
      description: "",
    })
    setIsAdd(true)
  }

  const handleEdit = (state) => {
    setFormActive(true)
    setIsAdd(false)
    setFormData({
      id: state.id,
      type: state.type,
      amount: state.amount,
      description: state.description,
    })
  }

  const handleActivate = async (id) => {
    try {
      await axios.patch(`/api/charges/activate/${id}`)
      setCharge((prev) =>
        prev.map((state) =>
          state.id === id ? { ...state, is_active: true } : state
        )
      )
    } catch (err) {
      alert(err.response?.data?.error || "Failed to activate")
    }
  }

  const handleDeactivate = async (id) => {
    try {
      await axios.patch(`/api/charges/deactivate/${id}`)
      setCharge((prev) =>
        prev.map((state) =>
          state.id === id ? { ...state, is_active: false } : state
        )
      )
    } catch (err) {
      alert(err.response?.data?.error || "Failed to deactivate")
    }
  }

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this charge?")) return

    try {
      await axios.delete(`/api/charges/delete/${id}`)
      setCharge((prev) => prev.filter((state) => state.id !== id))
    } catch (err) {
      alert(err.response?.data?.error || "Failed to delete")
    }
  }

  return (
    <Page title={"Charge"} is_admin={true}>
      {!formActive && (
        <ButtonArea>
          <button
            onClick={() => {
              setFormActive(true)
              setIsAdd(true)
              resetForm()
            }}
          >
            Add Charge
          </button>
        </ButtonArea>
      )}

      {formActive && (
        <Form is_admin={true} onSubmit={handleSubmit}>
          <div>
            <div>
              <label htmlFor="type">Charge Type</label>
              <select
                name="type"
                id="type"
                value={formData.type}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    type: e.target.value,
                  })
                }
              >
                <option value="">Select a type</option>
                {types.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
              {/* <p>Selected: {formData.type}</p> */}

              {/* <input
                list="types"
                id="type"
                value={formData.type}
                onChange={isAdd ? handleInputChange : ""}
                placeholder="Charge Type"
                required
              />
              <datalist id="types">
                {types.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
                {/* Add more options as needed */}
              {/* </datalist> */}
            </div>
          </div>
          <div>
            <div>
              <label htmlFor="amount">
                Amount in ₹ or percentage (25, 10%)
              </label>
              <input
                type="text"
                id="amount"
                value={formData.amount}
                onChange={handleInputChange}
                placeholder="Amount"
                required
              />
            </div>
          </div>
          <div>
            <div>
              <label htmlFor="description">description</label>
              <input
                type="text"
                id="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="description"
                required
              />
            </div>
          </div>

          <ButtonArea>
            <button type="submit">{isAdd ? "Add" : "Update"} Charge</button>
            <button
              type="button"
              onClick={() => {
                setFormActive(false)
                resetForm()
              }}
            >
              Close
            </button>
          </ButtonArea>
        </Form>
      )}

      {loading && (
        <div style={{ height: "calc(100svh - 100px)", display: "flex" }}>
          <div style={{ margin: "auto" }}>
            <Loader />
          </div>
        </div>
      )}

      {!loading && !error && !formActive && (
        <ResponsiveTable>
          <thead>
            <tr>
              <th>Id</th>
              <th>Type</th>
              <th>Amount</th>
              <th>description</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {charge.map((state) => (
              <tr key={state.id}>
                <td data-label="Id">{state.id}</td>
                <td data-label="Type">{state.type}</td>
                <td data-label="Amount">{state.amount}</td>
                <td data-label="description">{state.description}</td>
                <td data-label="Status">
                  {!state.is_active ? (
                    <button
                      onClick={() => handleActivate(state.id)}
                      style={{
                        marginLeft: "5px",
                        padding: "3px 6px",
                        fill: "red",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      <ToggleOffIcon />
                    </button>
                  ) : (
                    <button
                      onClick={() => handleDeactivate(state.id)}
                      style={{
                        marginLeft: "5px",
                        padding: "3px 6px",
                        fill: "green",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      <ToggleOnIcon />
                    </button>
                  )}
                </td>
                <td data-label="Actions">
                  <button
                    onClick={() => handleEdit(state)}
                    style={{
                      padding: "3px 6px",
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                    }}
                  >
                    <EditIcon />
                  </button>
                  <button
                    onClick={() => handleDelete(state.id)}
                    style={{
                      padding: "3px 6px",
                      border: "none",
                      background: "none",
                      color: "red",
                      cursor: "pointer",
                    }}
                  >
                    <DeleteIcon />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </ResponsiveTable>
      )}
    </Page>
  )
}

export default ChargePage
